// extracted by mini-css-extract-plugin
module.exports = {"base":"InfoSection_base__kcyHJ","contentSection":"InfoSection_contentSection__xaahB"};